import { apiClient, fastApiClient } from "../App";

// Get Campaign List

export const getCampaigns = (status = "all", channel = "email", extra = {}) => {
  const params = new URLSearchParams();

  if (status !== "all") {
    params.append("status", status);
  }

  if (channel) {
    params.append("simulation_type", channel);
  }

  // search jaisi extra keys yaha query me judti hain
  Object.entries(extra).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      params.append(key, value);
    }
  });

  const query = params.toString() ? `?${params.toString()}` : "";

  return fastApiClient.get(`/campaigns${query}`);
};

// Get Email Templates
export const getEmailTemplates = async () => {
  const response = await fastApiClient.get("/email-templates");
  return response.data;
};

// Get User Groups
export const getUserGroups = async () => {
  const response = await apiClient.get("/user-groups");
  return response.data;
};

// Get Departments
export const getDepartments = async () => {
  const response = await apiClient.get("/departments");
  return response.data;
};

// Get Landing Pages
export const getLandingPages = async () => {
  const response = await apiClient.get("/landing-pages");
  return response.data;
};

// Get SMTP Configurations
export const getSmtpConfigs = async () => {
  const response = await apiClient.get("/smtp-configs");
  return response.data;
};

// Get Twilio Configurations
export const getTwilioConfigs = async () => {
  const response = await apiClient.get("/twilio-configs");
  return response.data;
};

// Get Voices
export const getVoices = async () => {
  const response = await apiClient.get("/voices");
  return response.data;
};

// Create Campaign
export const createCampaign = async (payload) => {
  const response = await fastApiClient.post("/campaigns", payload);
  return response.data;
};

// Update Campaign
export const updateCampaign = async (id, payload) => {
  const response = await fastApiClient.put(`/campaigns/${id}`, payload);
  return response.data;
};

// Delete Campaign
export const deleteCampaign = async (id) => {
  const response = await fastApiClient.delete(`/campaigns/${id}`);
  return response.data;
};

// Execute Campaign
export const executeCampaign = async (id) => {
  const response = await fastApiClient.post(`/campaigns/${id}/execute`);
  return response.data;
};

// Pause Campaign
export const pauseCampaign = async (id) => {
  const response = await fastApiClient.post(`/campaigns/${id}/pause`);
  return response.data;
};

// Resume Campaign
export const resumeCampaign = async (id) => {
  const response = await fastApiClient.post(`/campaigns/${id}/resume`);
  return response.data;
};

// Bulk Delete Campaigns
export const bulkDeleteCampaigns = async (campaignIds) => {
  const response = await fastApiClient.post("/campaigns/bulk-delete", campaignIds);
  return response.data;
};

// Bulk Export Campaigns
export const bulkExportCampaigns = (campaignIds) => {
  return fastApiClient.post("/campaigns/bulk-export", campaignIds, {
    responseType: "blob",
  });
};